import { render, staticRenderFns } from "./UnitSizesPage.vue?vue&type=template&id=6778699f&scoped=true&"
import script from "./UnitSizesPage.vue?vue&type=script&lang=js&"
export * from "./UnitSizesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778699f",
  null
  
)

export default component.exports